import User from 'classes/User';
import { combineReducers } from 'redux';

import UserTypes from './types';

const user = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case '@@USER/SET_USER':
        const u = action.user.customer;
        localStorage.setItem('id', u.id);
        localStorage.setItem('name', u.name);
        localStorage.setItem('user_type', u.type);
        localStorage.setItem('photo', u.photo);
        localStorage.setItem('eadCharging', u.eadCharging);
        localStorage.setItem('newbie', u.newbie);
        localStorage.setItem('blinket_url', u.blinket_url);
        localStorage.setItem('account_currency', u.account_currency);
        return new User(action.user.customer);
      case request:
        return { ...state, isFetching: true };
      case success:
        return new User(action.payload.data.customer);
      case error:
        return { ...action.error, ...state, isFetching: false };
      default:
        return state;
    }
  };
};

const originalUser = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case '@@ORIGINAL_USER/SET_USER':
        return new User(action.user.original_customer);
      case success:
        return new User(action.payload.data.original_customer);
      case error:
        return { ...action.error, ...state, isFetching: false };
      default:
        return state;
    }
  };
};

export const userReducer = combineReducers({
  listAffiliates: UserTypes.listAffiliates.getReducer(),
  listCoupons: UserTypes.listCoupons.getReducer(),
  user: UserTypes.user.createReducer(user),
  originalUser: UserTypes.originalUser.createReducer(originalUser),
});
